import React, { useEffect } from 'react';
import { useLocation, Link } from 'react-router-dom';
import { imageUrl } from '../lib/images';

export default function Footer() {
  const location = useLocation();
  const isSubpage = location.pathname !== '/' && location.pathname !== '';

  useEffect(() => {
    // Initialiser iubenda embed badges når footeren mounter eller ruten skifter
    const s = document.createElement('script');
    s.src = 'https://cdn.iubenda.com/iubenda.js';
    s.async = true;
    document.body.appendChild(s);

    return () => {
      if (s.parentNode) {
        s.parentNode.removeChild(s);
      }
    };
  }, [location.pathname]);

  return (
    <footer className={`w-full bg-white ${isSubpage ? '' : 'border-t-[3px] border-[#235c6e]'} py-16`}>
      <div className="max-w-[1400px] mx-auto px-6 lg:px-12 grid grid-cols-1 md:grid-cols-3 lg:grid-cols-5 gap-8 lg:gap-10 items-start">
        {/* Column 1: Brand / About */}
        <div className="flex flex-col">
          <h2 className="text-[#1e4d65] font-bold text-lg leading-snug">
            KoppLaw Advokatpartnerselskab // Advokatfirmaet Kopp ApS
          </h2>
          <p className="mt-6 text-sm text-[#555555] leading-relaxed max-w-[220px]">
            Advokatfirma med fokus på miljø og bæredygtighed
          </p>
        </div>

        {/* Column 2: Kontakt */}
        <div>
          <h3 className="text-[#1e4d65] font-bold text-lg mb-5">Kontakt</h3>
          <ul className="space-y-3.5 text-sm font-semibold text-[#1a1a1a]">
            <li className="flex items-center gap-3">
              <i className="fa-solid fa-phone text-[#1a1a1a] text-sm w-4" aria-hidden="true" />
              <a href="tel:004551627235" className="hover:underline hover:text-[#1e4d65] transition-colors whitespace-nowrap">
                (+45) 5162 7235
              </a>
            </li>
            <li className="flex items-center gap-3">
              <i className="fa-solid fa-envelope text-[#1a1a1a] text-sm w-4" aria-hidden="true" />
              <a href="mailto:tk@kopplaw.dk" className="hover:underline hover:text-[#1e4d65] transition-colors whitespace-nowrap">
                tk@kopplaw.dk
              </a>
            </li>
            <li className="flex items-center gap-3">
              <i className="fa-solid fa-id-card text-[#1a1a1a] text-sm w-4" aria-hidden="true" />
              <span className="whitespace-nowrap">CVR: 44552795</span>
            </li>
            <li className="flex items-center gap-3">
              <i className="fa-brands fa-linkedin text-[#1a1a1a] text-base w-4" aria-hidden="true" />
              <a
                href="https://www.linkedin.com/in/titti-kopp-31611517/"
                target="_blank"
                rel="noopener noreferrer"
                className="hover:underline hover:text-[#1e4d65] transition-colors"
              >
                LinkedIn
              </a>
            </li>
          </ul>
        </div>

        {/* Column 3: Generelt */}
        <div>
          <h3 className="text-[#1e4d65] font-bold text-lg mb-5">Generelt</h3>
          <ul className="space-y-3.5 text-sm font-bold text-[#1a1a1a]">
            <li>
              <a
                href="https://www.iubenda.com/privacy-policy/68646505"
                className="iubenda-white iubenda-noiframe iubenda-embed hover:text-[#1e4d65] transition-colors"
                title="Privatlivspolitik "
              >
                Privatlivspolitik
              </a>
            </li>
            <li>
              <a
                href="https://www.iubenda.com/privacy-policy/68646505/cookie-policy"
                className="iubenda-white iubenda-noiframe iubenda-embed hover:text-[#1e4d65] transition-colors"
                title="Cookiepolitik "
              >
                Cookiepolitik
              </a>
            </li>
            <li>
              <a
                href="/_assets/forretningsbetingelser-advokatfirmaet-kopp-aps.pdf"
                target="_blank"
                rel="noopener noreferrer"
                className="hover:text-[#1e4d65] transition-colors"
              >
                Forretningsbetingelser
              </a>
            </li>
            <li>
              <a
                href="/_assets/medlemsskaber-mv-advokatfirmaet-kopp-aps.pdf"
                target="_blank"
                rel="noopener noreferrer"
                className="hover:text-[#1e4d65] transition-colors"
              >
                Medlemskaber mv.
              </a>
            </li>
          </ul>
        </div>

        {/* Column 4: Fagområder */}
        <div>
          <h3 className="text-[#1e4d65] font-bold text-lg mb-5">Fagområder</h3>
          <ul className="space-y-3.5 text-sm font-bold text-[#1a1a1a]">
            <li>
              <Link to="/fagomraader/miljoevurdering/" className="hover:text-[#1e4d65] transition-colors">
                Miljøvurdering
              </Link>
            </li>
            <li>
              <Link to="/fagomraader/natur-vand-miljoe/" className="hover:text-[#1e4d65] transition-colors">
                Natur, Vand & Miljø
              </Link>
            </li>
            <li>
              <Link to="/fagomraader/planforhold/" className="hover:text-[#1e4d65] transition-colors">
                Planforhold
              </Link>
            </li>
            <li>
              <Link to="/fagomraader/klima-baeredygtighed/" className="hover:text-[#1e4d65] transition-colors">
                Klima & Bæredygtighed
              </Link>
            </li>
            <li>
              <Link to="/fagomraader/bygherreraadgivning/" className="hover:text-[#1e4d65] transition-colors">
                Bygherrerådgivning
              </Link>
            </li>
            <li>
              <Link to="/fagomraader/ekspropriation-ledninger-mv/" className="hover:text-[#1e4d65] transition-colors">
                Ekspropriation, ledninger mv.
              </Link>
            </li>
          </ul>
        </div>

        {/* Column 5: Certifikat */}
        <div>
          <h3 className="text-[#1e4d65] font-bold text-lg mb-5">Certifikat</h3>
          <div className="mt-2">
            <a
              href="https://www.advokatsamfundet.dk/"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Advokatsamfundet medlem"
              className="inline-block"
            >
              <img
                src={imageUrl('advokatsamfundet-logo-dk-black-rgb-1024x241.jpg', 'width=400,quality=85,format=auto')}
                alt="Advokatsamfundet"
                className="h-10 w-auto object-contain hover:opacity-85 transition-opacity"
              />
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
